export default __webpack_public_path__ + "static/media/7Auwp_0qiz-afTzGLRrX.ce811984.woff2";